import React from "react";
import { Navigate } from "react-router-dom";

const UserLogin = React.lazy(() => import("../pages/auth/UserLogin"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
// const QuoteManagement = React.lazy(() => import("../pages/quoteManagement"));
const CreateQuote = React.lazy(() => import("../pages/quoteManagement/Create"));
const Error500 = React.lazy(() => import("../pages/Error500"));
const Error404 = React.lazy(() => import("../pages/Error404"));

export const ROUTES = {
  USER_LOGIN: {
    path: "/auth/user-login",
    element: <UserLogin />,
    isProtected: false,
  },
  LOGOUT: {
    path: "/auth/logout",
    element: <Logout />,
    isProtected: false,
  },
  // QUOTE: {
  //   path: "/quote",
  //   element: <QuoteManagement />,
  //   isProtected: true,
  // },
  CREATE_QUOTE: {
    path: "/create-quote",
    element: <CreateQuote />,
    isProtected: true,
  },
  ERROR500: {
    path: "/500",
    element: <Error500 />,
    isProtected: false,
  },
  ERROR404: {
    path: "/404",
    element: <Error404 />,
    isProtected: false,
  },
  DEFAULT: {
    path: "*",
    element: <Navigate to={"/404"} replace />,
    isProtected: false,
  },
};


export const routes = Object.values(ROUTES);
